import { MatchTypeApi } from 'videoservice-openapi-react';
import { apiConfig } from 'shared/api';

export const matchTypeApi = new MatchTypeApi(apiConfig);
